<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.userName"
              placeholder="请输入零售户名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.phone"
              placeholder="请输入零售户电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
      />
    </div>
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 数据请求
import { loadAppActivityDisplayCompetitionInfoListDataApi, loadAppActivityDisplayCompetitionInfoExportDataApi } from '@/api/appActivityDisplayCompetition'

export default {
  name: 'AppActivityDisplayCompetitionInfo',
  components: {
    CustomTable,
    TableOperation
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'app_activity_display_competition_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['app_activity_display_competition_info_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            userName: '',
            phone: ''
          }
        }
      },
      baseUrl: process.env.VUE_APP_BASE_API,
      id: null,
      dialogViewVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'activityName', filterColumn: 'd.name', label: '活动名称', width: 160 },
      { prop: 'itemName', filterColumn: 't.name', label: '批次名称', width: 160 },
      { prop: 'startDateStr', filterColumn: 't.start_date', label: '开始日期', width: 120 },
      { prop: 'endDateStr', filterColumn: 't.end_date', label: '结束日期', width: 120 },
      { prop: 'provinceName', filterColumn: 'sau.province_name', label: '省区', width: 120 },
      { prop: 'cityName', filterColumn: 'sau.city_name', label: '城市', width: 120 },
      { prop: 'countyName', filterColumn: 'sau.county_name', label: '区县', width: 120 },
      { prop: 'userName', filterColumn: 'sau.name', label: '零售户', width: 120 },
      { prop: 'phone', filterColumn: 'sau.phone', label: '电话', width: 120 },
      { prop: 'storeName', filterColumn: 'sau.store_name', label: '店名', width: 160 },
      { prop: 'certificateNo', filterColumn: 'sau.certificate_no', label: '专卖证号', width: 160 },
      { prop: 'benxiangStoreNo', filterColumn: 'sau.benxiang_store_no', label: '本香门店码', width: 160 },
      { prop: 'commitTimeStr', filterColumn: 'i.commit_time', label: '提报时间', width: 160 },
      { prop: 'headPic', label: '门头照', width: 100, isImage: true },
      { prop: 'wholePic', label: '条包柜照', width: 100, isImage: true },
      { prop: 'detailPic', label: '小包柜照', width: 100, isImage: true },
      // { prop: 'aiRuleResultStr', filterColumn: 'i.ai_rule_result', filterValue: 'aiRuleResult', label: 'ai识别结果', width: 140, filterArray: [{ label: '不及格', value: 0 }, { label: '及格', value: 1 }, { label: '良好', value: 2 }, { label: '优秀', value: 3 }] },
      // { prop: 'aiError', filterColumn: 'i.ai_error', label: '识别错误原因', width: 140 },
      { prop: 'integral', filterColumn: 'i.integral', label: '获得积分', width: 120 },
      { prop: 'auditResultStr', filterColumn: 'i.audit_result', filterValue: 'auditResult', label: '审核结果', width: 140, filterArray: [{ label: '未审核', value: 0 }, { label: '及格', value: 1 }, { label: '良好', value: 2 }, { label: '优秀', value: 3 }, { label: '不及格', value: 4 }] },
      { prop: 'auditRemark', filterColumn: 'i.audit_remark', label: '审核意见', width: 160 },
      { prop: 'auditorName', filterColumn: 'i.auditor_name', label: '审核人', width: 150 },
      { prop: 'auditTimeStr', filterColumn: 'i.audit_time', label: '审核时间', width: 160, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadAppActivityDisplayCompetitionInfoListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        data.forEach(element => {
          let headPic = []
          headPic.push(this.baseUrl + element['headPic'])
          element.headPic = headPic
          let wholePic = []
          wholePic.push(this.baseUrl + element['wholePic'])
          element.wholePic = wholePic
          let detailPic = []
          detailPic.push(this.baseUrl + element['detailPic'])
          element.detailPic = detailPic
        })
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadAppActivityDisplayCompetitionInfoExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
